import React, { useState } from 'react';
import axios from 'axios';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [done, setDone] = useState(false);

  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (password.length < 6) {
      setMessage('Password must be at least 6 characters.');
      setIsError(true);
      return;
    }

    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      setIsError(true);
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      setMessage('Password reset successfully! Redirecting to login...');
      setIsError(false);
      setDone(true);
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    } catch (error) {
      const msg = error.response?.data?.error || 'Invalid or expired reset link.';
      setMessage(msg);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="card" style={{ maxWidth: '520px', margin: '40px auto', textAlign: 'center' }}>
        <h2 style={{ marginTop: 0, color: '#333' }}>Invalid Reset Link</h2>
        <p style={{ color: '#666' }}>This reset link is missing or invalid.</p>
        <a href="/" style={{ color: '#667eea', textDecoration: 'underline' }}>Back to login</a>
      </div>
    );
  }

  return (
    <div className="card" style={{ maxWidth: '520px', margin: '40px auto' }}>
      <h2 style={{ marginTop: 0, marginBottom: '12px', color: '#333' }}>
        Set a new password
      </h2>
      <p style={{ marginTop: 0, color: '#666' }}>
        Enter your new password below.
      </p>

      {message && (
        <div style={{
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          background: isError ? '#fef2f2' : '#ecfdf5',
          color: isError ? '#991b1b' : '#065f46',
          fontSize: '14px'
        }}>
          {message}
        </div>
      )}

      {!done && (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>New Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      )}

      <div style={{ marginTop: '16px' }}>
        <a href="/" style={{ color: '#667eea', textDecoration: 'underline', fontSize: '14px' }}>
          Back to login
        </a>
      </div>
    </div>
  );
}

export default ResetPassword;
